/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { customersRetrieve } from "../../funcs/customersRetrieve.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  customerId: z.string().optional(),
  email: z.string().optional(),
};

export const tool$customersRetrieve: ToolDefinition<typeof args> = {
  name: "customers-retrieve",
  description: `Retrieve a customer

Retrieve customer information by ID or email. View purchase history, subscriptions, and profile details.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await customersRetrieve(
      client,
      args.customerId,
      args.email,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
